module.exports = __webpack_public_path__ + "static/background-b1ef8a0cbaadeef8f80b39b45f4fd20d.png";